// initial state
import * as base from './base.js'
const baseName = '/admin/api/show'
const baseCategoryName = '/admin/api/show_category'
const showbaseCategory = '/admin/api/show_category/lists'

const obj = base.setBaseUrl('show', baseName)
const obj1 = base.setBaseUrl('show_category', baseCategoryName)

const a = Object.assign(obj,obj1, {showbaseCategory})
export default a
